import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const LogoImg = ({ className }) => (
  <img src="/brand/yk-logo.png" alt="YK Motors" width={1387} height={269} className={cn("block h-full w-auto", className)} />
);

export const Logo = ({ className, testId = "header-logo-link" }) => (
  <Link to="/" data-testid={testId} aria-label="YK Motors home" className={cn("inline-flex shrink-0", className)}>
    <LogoImg />
  </Link>
);
